import { render, staticRenderFns } from "./Workloads.vue?vue&type=template&id=2dfdca4a"
import script from "./Workloads.vue?vue&type=script&lang=js"
export * from "./Workloads.vue?vue&type=script&lang=js"
import style0 from "./Workloads.vue?vue&type=style&index=0&id=2dfdca4a&prod&lang=scss"
import style1 from "./Workloads.vue?vue&type=style&index=1&id=2dfdca4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports